import { createColumnText, widthOptions } from '@/components/table/function/createColumn';
export const columns = () => {
  return [
    createColumnText('รหัส', 'code', widthOptions(150)),
    createColumnText('ชื่อเมนูหลัก', 'headername', widthOptions(150)),
    createColumnText('ชื่อเมนูย่อย', 'subname', widthOptions(150)),
  ];
};
